import { useCallback, useEffect } from 'react'
import jwtDecode from 'jwt-decode'
import { useDispatch } from 'react-redux'
import { logout } from 'redux/thunks/api'
import { TOKEN } from 'util/session-constants'
import { getFromStorage } from 'util/storage'
import { toast } from 'util/toast'
import Scenes, { SceneValues } from 'util/Scenes'

export default (scene: SceneValues, handleBackToEmailScene: () => void) => {
  const dispatch = useDispatch()
  const token = getFromStorage(TOKEN)

  const handleSessionEnd = useCallback(async () => {
    await dispatch(logout(true))
    handleBackToEmailScene()
    toast.error(
      <p className="m-1.5 leading-4">
        Your MFA session has expired. Please re-enter your login credentials to try again.
      </p>,
    )
  }, [handleBackToEmailScene])

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null
    if (token && (scene === Scenes.login.generateMfa || scene === Scenes.login.verifyMfa)) {
      // Decode the token to get the expiration time
      const {
        exp,
        user: { type },
      }: { exp: number; user: { type: string } } = jwtDecode(token)
      // Set interval to test current time against expiration time
      if (type === 'mfa') {
        interval = setInterval(() => {
          const timeLeft = exp * 1000 - Date.now()

          if (timeLeft <= 0) {
            handleSessionEnd()
          }
        }, 1000)
      }
    }
    return () => {
      if (interval) {
        clearInterval(interval)
        interval = null
      }
    }
  }, [scene, handleSessionEnd, token])
}
